import { Modal, List, Button, Input, message } from "antd";
import { useState, useEffect } from "react";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import {
  useDisplayClients,
  useInsertProjectClient,
  useDeleteProjectClient,
} from "../Hooks/homepage/client";
import { uploadData, remove } from "aws-amplify/storage";

export default function ModifyClientModal({ open, onCancel }) {
  const { data, refetch } = useDisplayClients();
  const [insertClient] = useInsertProjectClient();
  const [deleteClient] = useDeleteProjectClient();
  const [clients, setClients] = useState([]);
  const [newClientName, setNewClientName] = useState("");
  const [uploadedImagePath, setUploadedImagePath] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data && data.home_page_project_client) {
      setClients(data.home_page_project_client);
    }
  }, [data]);

  const handleDeleteClient = async (client) => {
    try {
      setLoading(true);

      // Delete S3 File
      if (client.path && !client.path.includes("http")) {
        try {
          await remove({ path: "public/" + client.path });
        } catch (error) {
          console.error("Error deleting file from S3:", error);
        }
      }

      // Delete database record using name as identifier
      await deleteClient({ variables: { name: client.name } });

      message.success("Client deleted successfully!");
      refetch();
      setLoading(false);
    } catch (err) {
      console.error("Error deleting client:", err);
      message.error("Failed to delete client");
      setLoading(false);
    }
  };

  const handleFileUpload = async (file) => {
    try {
      setLoading(true);

      const fileExtension = file.name.split(".").pop();
      const fileName = `${newClientName}.${fileExtension}`;

      const s3Path = `public/websitePicture/Client Logo/${fileName}`;

      await uploadData({
        path: s3Path,
        data: file,
      }).result;

      const uploadedUrl = s3Path.replace("public/", "");
      setUploadedImagePath(uploadedUrl);

      message.success("Image uploaded successfully!");
      setLoading(false);
    } catch (error) {
      console.error("Upload failed:", error);
      message.error("Failed to upload image");
      setLoading(false);
    }
  };

  const handleSubmitNewClient = async () => {
    if (newClientName && uploadedImagePath) {
      try {
        setLoading(true);

        await insertClient({
          variables: {
            object: {
              name: newClientName,
              path: uploadedImagePath,
            },
          },
        });

        setNewClientName("");
        setUploadedImagePath("");

        message.success("Client added successfully!");
        refetch();
        setLoading(false);
      } catch (err) {
        console.error("Error inserting client:", err);
        message.error("Failed to add client");
        setLoading(false);
      }
    }
  };

  const ClientUploadButton = () => {
    const handleFileChange = (e) => {
      const file = e.target.files[0];
      if (file) {
        handleFileUpload(file);
      }
    };

    return (
      <>
        <input
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          id="client-file-upload"
          onChange={handleFileChange}
        />
        <Button
          icon={<UploadOutlined />}
          onClick={() => document.getElementById("client-file-upload").click()}
          disabled={!newClientName.trim() || loading}
          style={{ marginTop: 16 }}
        >
          Upload Client Logo
        </Button>
      </>
    );
  };

  return (
    <Modal
      title="Modify Clients"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={600}
      style={{ top: 20 }}
    >
      <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <div style={{ marginBottom: 24 }}>
          <h3>Existing Clients</h3>
          <List
            bordered
            dataSource={clients}
            renderItem={(client) => (
              <List.Item
                key={client.name}
                actions={[
                  <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => handleDeleteClient(client)}
                    disabled={loading}
                  />,
                ]}
              >
                <div style={{ fontWeight: "500" }}>{client.name}</div>
              </List.Item>
            )}
            locale={{ emptyText: "No clients found" }}
          />
        </div>

        <div style={{ borderTop: "1px solid #f0f0f0", paddingTop: 24 }}>
          <h3>Add New Client</h3>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 16,
              alignItems: "flex-start",
            }}
          >
            <Input
              placeholder="Enter client name"
              value={newClientName}
              onChange={(e) => setNewClientName(e.target.value)}
              style={{ width: "100%" }}
            />

            {newClientName.trim() && !uploadedImagePath && (
              <ClientUploadButton />
            )}

            {uploadedImagePath && (
              <Button
                type="primary"
                onClick={handleSubmitNewClient}
                disabled={loading}
                style={{ marginTop: 8 }}
              >
                Submit New Client
              </Button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}
